import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import WebLocalSiteInfo from "./WebLocalSiteInfo";

const WebLocalSiteList = ({ list_localSite, handleSelectedFunc }) => {
    const { t } = useTranslation();

    return (
        <div className="d-flex flex-column w-100 my-2">
            {
                // teacher/class 탭과 동일한 table-container / list-table 스타일 (내용·데이터 흐름은 동일)
                list_localSite && list_localSite.length > 0 ?
                    <div className="table-container">
                        {/* 260804-7 사이트 이름 말줄임(...) 실제 동작을 위해 table-layout:fixed 적용 */}
                        <table className="list-table admin-ellipsis-table">
                            <thead>
                                <tr>
                                    {/* 20260828 다국어 키 통일: Seq. -> 순번 */}
                                    <th style={{ width: '10%' }} className="text-center">{t("순번", { ns: "admin" })}</th>
                                    <th style={{ width: '70%' }} className="text-center">{t("로컬_사이트_이름", { ns: "admin" })}</th>
                                    <th style={{ width: '10%' }} className="text-center">{t("오픈_사이트", { ns: "admin" })}</th>
                                    <th style={{ width: '10%' }} className="text-center" />
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    list_localSite.map((localSite, idx) => (
                                        <WebLocalSiteInfo
                                            key={"config-local-site-" + idx}
                                            idx={idx}
                                            localSite_info={localSite}
                                            handleSelectedFunc={handleSelectedFunc}
                                        />
                                    ))
                                }
                            </tbody>
                        </table>
                    </div> :
                    <div className="d-flex view m-3 justify-content-center grey-text" style={{ fontSize: '1rem' }}>
                        {t("관리_가능한_로컬_사이트_목록_없음", { ns: "admin" })}
                    </div>
            }
        </div>
    );
}

export default WebLocalSiteList;